import React, { useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, GpsBaseURL, uniqueToken, Role } from '../../api/DataApis';

import { Link, Navigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "../Users/User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { createRoot } from "react-dom/client";



  const ViewMailSentUsers = () => {
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [Users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
 
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [file, setFile] = useState(null); // State to hold the selected file
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [UserID, setUserID] =  useState([]);
  const [selectEmail, setSelectEmail] = useState("");
  const [Loaders, setLoaders] =  useState(false);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [CorporateData, setCorporateData] =  useState([]);
   const [ProductData, setProductData] =  useState([]);

  const params = useParams();
  const location = useLocation();
  let state = location.state?.state; // Access the state passed through Link
  const userViewData = location?.state?.userViewData
// let params = useParams();
    let ImportredID = params?.cid;
    let CorporateID = params?.fid;
   let excelID = params?.cid;
console.log("userViewData", userViewData);
console.log("stateee", state);


const fetchProduct = async (page) => {
  // let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/get/list?status=Active`);
  if (userViewData?.corporate_id) {
   let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/get/list?status=Active&corporate_id=${userViewData?.corporate_id}`);
  
 
  
try {
    const response = await axios.get(apiEndpoint, {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
      },
    });

    console.log("response", response);

    setProductData(response.data);
  // Assuming API returns totalCount for pagination
  } catch (error) {
    console.error("Error fetching users:", error);
  } 
};}

// Re-fetch users whenever searchTerm changes
useEffect(() => {
  fetchProduct();
}, []);
console.log("UserID", UserID);

  
 

  let navigate = useNavigate();


  const handleReset = (event) => {
    event.preventDefault()
    if(ImportredID) {
      navigate(`/view-mail-sent-users/${ImportredID}`, {
        state: location.state?.state // Retain the state
      });
    }
    else {
      // navigate(`/view-mail-sent-users/${CorporateID}`);
      navigate(`/view-mail-sent-users/${CorporateID}`, {
        state: location?.state?.state // Retain the state
      });
    }
    }
 document.title = "View Imported Users";


  
const handleselectedStatusType = (e) => {
  setselectedStatusType(e.target.value);
}
const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
 const fetchUsers = async (page) => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/email-processing/users?page=${page}&email_processing_id=${CorporateID}&searchText=&email_status=`);
    if(state) {
      apiEndpoint = decodeURIComponent(`${GpsBaseURL}/email-processing/users?page=${page}&email_processing_id=${CorporateID}&searchText=&email_status=${state}`);

    }
   
    const queryParams = [];
  if (searchQuery) queryParams.push(`&searchText=${searchQuery}`);
    if (selectStatusType) queryParams.push(`&email_status=${selectStatusType}`);
    
    
    const apiUrl = `${apiEndpoint}${queryParams.join('&')}`;
  
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
      setUsers(response.data.data || []);
       setFilteredData(response?.data?.data);
      setTotalCount(response?.data?.count || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.count / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchUsers(page);
  }, [searchTerm,  page]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  const handleSelectAll = () => {
    if (isSelectAllChecked) {
      // If "Select All" is checked, deselect all
      setUserID([]);
    } else {
      // If "Select All" is not checked, select all users
      const allUserIDs = Users.map((user) => user.user_id); // Assuming users is an array of user objects with _id
      setUserID([...UserID, ...allUserIDs]);
    }
    setIsSelectAllChecked(!isSelectAllChecked); // Toggle "Select All" checkbox state
  };

   useEffect(() => {
      // If all users are selected, check the "Select All" checkbox
      setIsSelectAllChecked(Users.length > 0 && UserID.length === Users.length);
    }, [UserID, Users]);
   
    
    
    
    

    const handlesendEmailChange = async (e) => {
     
      const value = e.target.value;
      let selectedProduct = null; // Declare outside to maintain value
    
      if (value) {
        try {
          const confirmation = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to send an email?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `<span id="swal-confirm-text">Yes, Send it!</span>`,
            cancelButtonText: "No, cancel!",
            showLoaderOnConfirm: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            preConfirm: async () => {
              try {
                // **Show Loader in Button**
                Swal.getConfirmButton().innerHTML = `<i class="fa fa-spinner fa-spin"></i> Sending...`;
                Swal.getConfirmButton().disabled = true;
    
                const title = document.getElementById("titleInput").value;
                const comment = document.getElementById("commentInput").value;
                const sendOption = document.querySelector('input[name="sendOption"]:checked').value;
    
                if (!title || !comment) {
                  Swal.showValidationMessage("Please provide both title and comment");
                  return false;
                }
    
                const response = await fetch(`${GpsBaseURL}/user/send-email`, {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${uniqueToken}`,
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    userIds: UserID,
                    title,
                    comment,
                    product_id: selectedProduct,
                    type: sendOption,
                  }),
                });
    
                const data = await response.json();
    
                // **Restore Button**
                Swal.getConfirmButton().innerHTML = `Yes, Send it!`;
                Swal.getConfirmButton().disabled = false;
    
                if (response.status === 200) {
                  Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: data.message,
                    showConfirmButton: true,
                  }).then(() => {
                    navigate("/email-processing-logs"); // ✅ Navigate after success message
                  });
                } else {
                  throw new Error(data.message || "Failed to send email");
                }
              } catch (error) {
                console.error("Error during request:", error);
                Swal.showValidationMessage("Failed to send email. Please try again.");
                Swal.getConfirmButton().innerHTML = `Yes, Send it!`;
                Swal.getConfirmButton().disabled = false;
              }
            },
            html: `
              <div id="select-product-container" style="margin-bottom: 10px;"></div>
    
              <div style="display: flex; flex-direction: column; align-items: flex-start;">
                <label for="titleInput" style="font-weight: bold; text-align: left; width: 100%;">Title</label>
                <input id="titleInput" class="form-control" placeholder="Enter Title" 
                      style="width: 100%; padding: 8px; margin-top: 5px; border-radius: 5px; border: 1px solid #ccc; text-align: left;">
                
                <label for="commentInput" style="margin-top: 10px; font-weight: bold; text-align: left; width: 100%;">Comment</label>
                <textarea id="commentInput" class="form-control" placeholder="Enter Your Comment" 
                          style="width: 100%; padding: 8px; margin-top: 5px; border-radius: 5px; border: 1px solid #ccc; height: 85px; text-align: left;"></textarea>
              </div>
    
              <div style="margin-top: 15px; display: flex; flex-direction: column; align-items: flex-start;">
                  <label style="display: flex; align-items: center; gap: 5px; text-align: left;">
                      <input type="radio" name="sendOption" value="send_all_user" id="sendAll">
                      Send to All Users
                  </label>
                  <label style="display: flex; align-items: center; gap: 5px; text-align: left; margin-top: 5px;">
                      <input type="radio" name="sendOption" value="selected_users" id="sendSelected" checked>
                      Send to Selected Users
                  </label>
              </div>
            `,
            didOpen: () => {
              const container = document.getElementById("select-product-container");
              if (container) {
                const root = createRoot(container);
                root.render(
                  <Select
                    options={ProductData.map((item) => ({
                      value: item._id,
                      label: item.title,
                    }))}
                    onChange={(option) => {
                      selectedProduct = option ? option.value : null;
                    }}
                    placeholder="Select Product"
                    isClearable
                    styles={{
                      control: (base) => ({
                        ...base,
                        width: "100%",
                        height: "38px",
                        fontSize: "14px",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        textAlign: "left",
                      }),
                      menu: (base) => ({
                        ...base,
                        textAlign: "left",
                      }),
                      option: (base) => ({
                        ...base,
                        textAlign: "left",
                        fontSize: "14px",
                      }),
                    }}
                  />
                );
              }
            },
          });
        } catch (error) {
          console.error("Error during request:", error);
          Swal.fire({
            icon: "error",
            title: "Request Failed",
            text: "An error occurred. Please try again later.",
          });
        }
      }
    };
    
    


  
  
  
 const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};
const handleUserID = (userID) => {
  
  setUserID((prevUserIDs) => {
    if (prevUserIDs.includes(userID)) {
      // If user is already selected, deselect them
      return prevUserIDs.filter((id) => id !== userID);
    } else {
      // If user is not selected, select them
      return [...prevUserIDs, userID];
    }
  });
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/email-processing/users?page=${page}&email_processing_id=${CorporateID}`
  const params = [];

  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
  if (selectedStatusType) {
    params.push(`email_status=${selectStatusType}`);
}


  // Add selected country, state, and city to the params


  // Append query parameters to the URL
  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res?.data?.data?.length); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.totalCount / Limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3"> Users(With E-male Status)({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>


</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap", // Allows wrapping on smaller screens
      }}
    >
   
    
    </div>

    {/* New line for next set of fields */}
    <div
      className="row px-3"
      style={{
        display: "flex",
        flexWrap: "wrap", // Allow wrapping on smaller screens
        marginTop: "10px", // Space between groups
      }}
    >
{state !== "Delivered" && state !== "NotDelivered" && (
  <div className="col-md-2 col-sm-12">
    <div className="form-group">
      <select
        value={selectStatusType}
        onChange={handleselectedStatusType}
        className="form-control select2 select2-offscreen"
        style={{
          height: "38px",
          width: "100%",
        }}
      >
        <option value="">Select Status</option>
        <option value="Delivered">Delivered</option>
        <option value="NotDelivered">NotDelivered</option>
      </select>
    </div>
  </div>
)}


      <div className="col-md-2 col-sm-12">
        <div className="form-group">
          <input
            placeholder="Find Data Here"
            className="form-control"
            style={{
              borderRadius: "8px",
              padding: "6px 10px",
              marginRight: "10px",
              height: "38px",
            }}
            value={searchQuery}
            onChange={handleSearchTextChange}
          />
        </div>
      </div>

      { UserID[0]  &&   (
  <>
<div className="col-md-2 col-sm-12">
  <div className="form-group">
    <select
     // Bind the dropdown's value to the state
      onChange={handlesendEmailChange} // Update state on selection change
      className="form-control select2 select2-offscreen"
      style={{
        height: "38px", // Consistent height
        width: '100%', // Make width responsive
      }}
    >
      <option value="">Select Option</option>
      <option value="email">Email</option>
     </select>
  </div>
</div>
</>
)}

      <div
        className="col-md-2 col-sm-12"
        style={{ display: "flex", alignItems: "center" }}
      >
        <button
          className="btn btn-primary"
          onClick={handleSearchSubmit}
          style={{
            marginLeft: "10px",
            height: "38px",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          Search
        </button>

        {/* <button
          className="btn btn-primary"
          onClick={handleReset}
          style={{
            marginLeft: "10px",
            height: "38px",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          Reset
        </button> */}
     
      </div>
    </div>
  </form>
</div>

{Loaders ? (
          <div className="spinner"></div> // Show spinner when loading
        ) : (
          ''
        )}



              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
  {CorporateID && state === "NotDelivered"  && (
  <th style={{display: "flex", alignItems: "center"}}>
  <input type="checkbox"   onClick={handleSelectAll} 
                checked={isSelectAllChecked}/>

  Select All
</th>
  )}

    <th style={{ minWidth: '80px' }}>Sr No</th>
    <th style={{ minWidth: '200px' }}>Name</th>
    <th style={{ minWidth: '270px' }}>Mobile</th>
    <th style={{ minWidth: '150px' }}>Email</th>
    <th>Email Status</th>
    <th style={{ minWidth: '150px' }}>Last Email Sent</th>
    <th style={{ minWidth: '150px' }}>Email Delivered Date</th>
 


    
   
  </tr>
</thead>

        <tbody>
          {filteredData?.map((user, index) => (
            <tr key={index}>
     {CorporateID && state=== "NotDelivered" && (
              <td>
       <input 
  type="checkbox" 
  onClick={() => handleUserID(user?.user_id)} 
  checked={UserID.includes(user.user_id)}
  style={{ marginRight: "8px" }} 
/>
</td>
              )}

              <td>{(page - 1) * Limit + index + 1}</td>
              <td>{user?.name}</td>
              <td>{user?.mobile}</td>
              <td>{user?.email}</td>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
  <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center", 
      color: "white",    // Centers content vertically
      backgroundColor:  
       
        user?.email_status === 'NotDelivered' ? '#d22d3d' :
        user?.email_status === 'Delivered' ? 'green' : 'purple',  // Default color
    }}
    className="btn"
  >
    {user?.email_status}
  </button></td>
              <td>{user?.last_email_sent}</td>
              <td>{user?.email_sent_Date}</td>
          
            </tr>
          ))}
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default ViewMailSentUsers;
